import { ADVICE_0_2 } from "./age0_2";
import { ADVICE_3_5 } from "./age3_5";
import { ADVICE_6_9 } from "./age6_9";
import { ADVICE_10_12 } from "./age10_12";
import { ADVICE_13_PLUS } from "./age13plus";

export const ADVICE = [
  ...ADVICE_0_2,
  ...ADVICE_3_5,
  ...ADVICE_6_9,
  ...ADVICE_10_12,
  ...ADVICE_13_PLUS,
];

// Sous-étapes ordonnées par tranche d'âge (un bébé de 3 mois n'a rien à voir avec un enfant de 2 ans)
export const STAGES = {
  "0-2": ["0-3 mois", "3-6 mois", "6-12 mois", "12-18 mois", "18-24 mois"],
  "3-5": ["3 ans", "4 ans", "5 ans", "Toute la tranche"],
  "6-9": ["6-7 ans", "8-9 ans", "Toute la tranche"],
  "10-12": ["10 ans", "11 ans", "12 ans", "Toute la tranche"],
  "13+": ["13-14 ans", "15-16 ans", "17 ans et +", "Toute la tranche"],
};
